/**
 * Returns an absolute URL for a Contentful asset field.
 * @param {object|undefined} assetField - Contentful asset linked field (e.g. fields.pdfFile)
 * @returns {string|undefined}
 */
export const resolveContentfulAssetUrl = (assetField) => {
  const url = assetField?.fields?.file?.url;
  if (!url) return undefined;
  return url.startsWith("//") ? `https:${url}` : url;
};
